import { html, nothing, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import { createRef, ref, type Ref } from "lit/directives/ref.js";
import type { Button } from "@/components/button";
import { when } from "@/common/directives/when";
import EkoElement from "@/utilities/element";
import "./page-header-title";
import style from "./page-header.css?inline";
import "./page-header-tooltip";

@customElement("eko-page-header")
class PageHeader extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  private showHelpModalButtonRef: Ref<Button> = createRef();

  @property({ reflect: true, type: Boolean }) help = false;
  @property({ reflect: true }) variant?: "default" | "plain"; // Default is "default";

  private showHelpModal() {
    const helpModal = this.querySelector(
      "eko-page-header-help-modal[slot='help']"
    ) as HTMLElement | null;

    if (helpModal) {
      (helpModal as any).show({ restoreFocusElement: this.showHelpModalButtonRef });
    }
  }

  render() {
    return html` <div>
      <div class="eko-page-header" part="root" variant=${when(this.variant)}>
        <div class="eko-page-header__main" part="main">
          <slot name="breadcrumbs"></slot>
          <div class="eko-page-header__content" part="content">
            <slot></slot>
            <div class="eko-page-header__tooltip" part="tooltip">
              ${this.help
                ? html` <eko-tooltip arrow>
                    <span slot="content">Learn more</span>
                    <eko-button
                      @click=${this.showHelpModal}
                      variant="plain"
                      square
                      ${ref(this.showHelpModalButtonRef)}
                      part="help-button">
                      <eko-icon name="info-circle" part="help-icon"></eko-icon>
                    </eko-button>
                  </eko-tooltip>`
                : nothing}
              <slot name="tooltip"></slot>
            </div>
          </div>
        </div>
        <slot name="actions"></slot>
      </div>
      <slot name="help"></slot>
      <slot name="tabs"></slot>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-page-header": PageHeader;
  }
}

export default PageHeader;
